import { render, staticRenderFns } from "./programas.vue?vue&type=template&id=b378b75a"
import script from "./programas.vue?vue&type=script&lang=js"
export * from "./programas.vue?vue&type=script&lang=js"
import style0 from "./programas.vue?vue&type=style&index=0&id=b378b75a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports